// Minimal inline SVG icon set (stroke-based, currentColor). Keeps the shell
// dependency-free. 24x24 viewBox, 1.8 stroke.
const P = (d) => `<svg class="ico" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round">${d}</svg>`

const ICONS = {
  hive:     P('<path d="M12 2 3 7v10l9 5 9-5V7z"/><path d="M12 8 8.5 10v4l3.5 2 3.5-2v-4z"/>'),
  send:     P('<path d="M22 2 11 13"/><path d="M22 2 15 22l-4-9-9-4z"/>'),
  inbox:    P('<path d="M22 12h-6l-2 3h-4l-2-3H2"/><path d="M5.5 5h13l3.5 7v6a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2v-6z"/>'),
  megaphone:P('<path d="m3 11 14-6v14L3 13z"/><path d="M17 8a4 4 0 0 1 0 8"/><path d="M6 13v4a2 2 0 0 0 2 2h1"/>'),
  bolt:     P('<path d="M13 2 4 14h7l-1 8 9-12h-7z"/>'),
  shield:   P('<path d="M12 2 4 6v6c0 5 3.5 8 8 10 4.5-2 8-5 8-10V6z"/><path d="m9 12 2 2 4-4"/>'),
  search:   P('<circle cx="11" cy="11" r="7"/><path d="m20 20-3.5-3.5"/>'),
  gauge:    P('<path d="M12 13 16 9"/><path d="M4 20a8 8 0 1 1 16 0"/><circle cx="12" cy="13" r="1.4"/>'),
  cog:      P('<circle cx="12" cy="12" r="3.2"/><path d="M12 2v3M12 19v3M4.2 4.2l2.1 2.1M17.7 17.7l2.1 2.1M2 12h3M19 12h3M4.2 19.8l2.1-2.1M17.7 6.3l2.1-2.1"/>'),
  headset:  P('<path d="M4 13v-1a8 8 0 0 1 16 0v1"/><path d="M4 13a2 2 0 0 1 2 2v2a2 2 0 0 1-4 0v-2a2 2 0 0 1 2-2z"/><path d="M20 13a2 2 0 0 1 2 2v2a2 2 0 0 1-4 0v-2a2 2 0 0 1 2-2z"/><path d="M20 17v1a3 3 0 0 1-3 3h-3"/>'),
  moon:     P('<path d="M21 12.8A8.5 8.5 0 1 1 11.2 3 6.6 6.6 0 0 0 21 12.8z"/>'),
  spark:    P('<path d="M12 3c.4 3.6 2.4 5.6 6 6-3.6.4-5.6 2.4-6 6-.4-3.6-2.4-5.6-6-6 3.6-.4 5.6-2.4 6-6z"/><path d="M19 14c.2 1.4 1 2.2 2.4 2.4-1.4.2-2.2 1-2.4 2.4-.2-1.4-1-2.2-2.4-2.4 1.4-.2 2.2-1 2.4-2.4z"/>'),
  webhook:  P('<circle cx="12" cy="7" r="3"/><path d="M10.5 9.5 7 16"/><circle cx="6" cy="18" r="2.5"/><path d="M8.5 18H15"/><circle cx="17.5" cy="18" r="2.5"/><path d="m15.5 16.5-2.5-4.5"/>'),
}

export function icon(key) { return ICONS[key] || ICONS.hive }

// Decorative honeycomb hex for the brand mark — Giggle turquoise→pink gradient
// with a charcoal core (the Hive structure, in Giggle's palette).
export const HEX_MARK = `
<svg class="hex" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
  <path d="M20 2 34.6 10.5V27.5L20 36 5.4 27.5V10.5z" fill="url(#hg)"/>
  <path d="M20 11 27 15V23L20 27 13 23V15z" fill="#2b2b2b"/>
  <defs><linearGradient id="hg" x1="4" y1="4" x2="36" y2="36" gradientUnits="userSpaceOnUse">
    <stop stop-color="#00e0e0"/><stop offset="1" stop-color="#fd4d96"/>
  </linearGradient></defs>
</svg>`
